import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Sun, Leaf, Users, BadgeCheck } from "lucide-react";
import { useLanguage } from "../i18n";

const ICONS = [Sun, Leaf, Users, BadgeCheck];

export const HomeIntro = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="home-intro" className="py-20 lg:py-28 bg-sand">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <motion.div className="lg:col-span-5" initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }}>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-amberdark mb-6">{t.home.introOverline}</p>
          <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tight leading-tight text-ink">{t.manifesto.title}</h2>
          <p className="mt-6 text-base text-inksoft leading-relaxed">{t.home.introText}</p>
          <Link to="/chi-siamo" data-testid="home-about-link" className="mt-8 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] text-ink border-b border-amberdark pb-1 hover:text-amberdark transition-colors">
            {t.home.introCta}<ArrowRight className="w-4 h-4" strokeWidth={1.5} />
          </Link>
        </motion.div>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
          {t.strengths.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div key={item.title} data-testid={`home-strength-${i}`} className="bg-white border border-ink/10 rounded-sm p-6 flex gap-4"
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }} transition={{ duration: 0.5, delay: i * 0.08 }}>
                <span className="inline-flex w-10 h-10 shrink-0 rounded-sm bg-sand items-center justify-center"><Icon className="w-5 h-5 text-amberdark" strokeWidth={1.5} /></span>
                <div>
                  <h3 className="font-display text-xl font-medium text-ink tracking-tight">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-inksoft line-clamp-3">{item.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
